/**
 * 分配window._env_的环境变量
 *
 * 环境变量从多种位置获取，优先级如下
 * window._containerEnv_ > modeEnv > processEnv
 *
 * window._containerEnv_ 默认在 docker run 时添加到 index.html
 * modeEnv 在 npm build 时获得的多个模式环境变量之一
 * processEnv 默认原始的.env.* 等文件中获取的环境变量
 */

// 全局最终环境配置
window._env_ = {}

// docker的环境配置
if (!window._containerEnv_) {
  window._containerEnv_ = {}
}

// 默认环境配置
const processEnv = {}
for (const envKey in process.env) {
  if (Object.prototype.hasOwnProperty.call(process.env, envKey)) {
    if (/^VUE_APP_/.test(envKey)) {
      processEnv[envKey] = process.env[envKey]
    }
  }
}

let modeEnv = {}
// 不同模式的环境变量
const modeEnvs = JSON.parse(process.env.VUE_APP_MODE_ENVS)
// 取得模式的环境变量
const mode = window._containerEnv_.VUE_APP_MODE || processEnv.VUE_APP_MODE
if (mode && Object.prototype.hasOwnProperty.call(modeEnvs, mode)) {
  modeEnv = modeEnvs[mode]
}

// 合并环境变量
window._env_ = Object.assign({}, processEnv, modeEnv, window._containerEnv_)

// 写入文档标题
document.title = window._env_.VUE_APP_NAME
